<template>
  <div class="main">
    <!-- 检索页 -->
    <!-- 搜索框 -->
    <div class="v_search">
      <!-- <el-card> -->
      <!-- <el-row :gutter="20">
        <el-col :span="4">
          <div class="left_btn bg-brand" @click="goVideoList('1')">
            <div class="tt">成片数据</div>
            <div class="f12">共{{productCount}}条数据</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="left_btn bg-success" @click="goVideoList('0')">
            <div class="tt">素材数据</div>
            <div class="f12">共{{materialCount}}条数据</div>
          </div>
        </el-col>
        <el-col :span="4" :offset="2">
          <el-select
            filterable
            allow-create
            default-first-option
            v-model="typeName"
            @change="selectTypeName"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.title"
              :value="item.title"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-input placeholder="名称/关键词/简介"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" icon="el-icon-search">综合检索</el-button>
        </el-col>
        <el-col :span="1">/</el-col>
        <el-col :span="3">
          <router-link to="/videolist2?from=false">
            <el-button>高级检索</el-button>
          </router-link>
        </el-col>
      </el-row>-->
      <el-row>
        <el-col :span="16">
          <div
            class="fl"
            style="display:flex;flex-direction:row;margin-right:10px;border-right:1px solid #f0f2f5;vertical-align:middle;"
          >
            <div class="cursor-poiner" style="padding:0 15px;" @click="goVideoLeft">
              <el-image style="width:25px;height:25px;vertical-align:middle;" :src="src1"></el-image>
              <span style="vertical-align:middle;">成片库</span>
            </div>
            <div>
              <el-divider direction="vertical"></el-divider>
            </div>
            <div class="cursor-poiner" style="padding:0 15px;" @click="goVideoRight">
              <el-image style="width:25px;height:25px;vertical-align:middle;" :src="src2"></el-image>
              <span style="vertical-align:middle;">素材库</span>
            </div>
          </div>
          <div class="fl">
            <!-- <span> <i style="font-size:18px;" class="el-icon-files"></i></span> -->
            <el-select
              filterable
              allow-create
              default-first-option
              v-model="typeName"
              @change="selectTypeName"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.title"
                :value="item.title"
              ></el-option>
            </el-select>
          </div>
          <div class="fl">
            <i class="line"></i>
          </div>
          <div class="fl">
            <!-- <i class="el-icon-search"></i> -->
            <el-input
              v-model="searchValue"
              style="font-size:16px;"
              prefix-icon="el-icon-search"
              placeholder="名称/关键词/简介"
            ></el-input>
          </div>
        </el-col>
        <el-col class="tar" :span="8">
          <el-button
            style="font-size:16px;background:#00aaff;color:#cfefff;"
            icon="el-icon-search"
            @click="integSearch"
          >综合检索</el-button>
          <router-link to="/videolist2?from=1">
            <el-button style="font-size:16px;">高级检索</el-button>
          </router-link>
        </el-col>
      </el-row>
      <!-- </el-card> -->
    </div>

    <!-- 面包屑导航 -->
    <div class="nav_bread" id="nav_bread">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>视频分类索引</el-breadcrumb-item>
            <!-- <el-breadcrumb-item>专题分类1</el-breadcrumb-item> -->
          </el-breadcrumb>
        </el-col>
        <el-col :span="12" class="tar f16">
          <span style="color:red;font-weight:bold;">{{contentName || $route.query.category}}</span>
          共检索
          <span style="color:red;">{{video+material}}</span>个结果
          <span>
            (成片
            <span style="color:red;">{{video}}</span>个 / 素材
            <span style="color:red;">{{material}}</span> 个)
          </span>
          <!-- <div class="fr nav-right-tab">
            <div></div>
            <div></div>
          </div>-->
        </el-col>
        <!-- <el-col :span="4">
          <el-checkbox label="单视频" v-model="isChecked1" @change="handleCheck1"></el-checkbox>
          <el-checkbox label="视频集" v-model="isChecked2" @change="handleCheck2"></el-checkbox>
        </el-col>-->
        <!-- <el-col :span="10">
          <el-input placeholder="请输入视频标题" v-model="title" @change="selectValue"></el-input>
          <el-button type="primary" @click="select">搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button plain type="primary">高级搜索</el-button>
        </el-col>-->
      </el-row>
    </div>
    <!-- 检索分类 -->
    <div class="sea-list">
      <div
        v-show="item.list.length > 0"
        class="sea-tab"
        v-for="item in gateImgList"
        :key="item.category"
      >
        <el-row class="sea-title">
          <el-col class="tal" :span="12">
            <h3 v-if="item.category" class="text-color-blue">{{item.category }}门类</h3>
            <h3 v-if="item.contentType" class="text-color-blue">{{item.contentType }}</h3>
          </el-col>
          <el-col class="tar" :span="12">
            <a href="javascript:;" @click="checkAllData(item.category,item.contentType)">
              查看全部
              <span class="red">{{item.totalCount}}</span> 个结果>>
            </a>
          </el-col>
        </el-row>
        <el-row class="imgListFlow">
          <ul class>
            <li v-for="(item2,index) in item.list" :key="item2.id" :title="item2.groupName">
              <div style="cursor: pointer;">
                <el-image
                  @click="goDetail(item2.id)"
                  style="width: 250px; height: 140px;"
                  :src="item2.fileLocation"
                  fit="cover"
                ></el-image>
                <h4>{{item2.fileName}}</h4>
                <div class="li-search-text">
                  <div>相关人物：{{item2.personName}}</div>
                  <div v-if="item2.contentType == 'NEWS'">数据源：新闻类</div>
                  <div v-if="item2.contentType == 'LIVE'">数据源：直播类</div>
                  <div v-if="item2.contentType == 'VIEW'">数据源：访谈类</div>
                  <div v-if="item2.contentType == 'WORKS'">数据源：作品类</div>
                  <div v-if="item2.contentType == 'OTHER'">数据源：其他类</div>
                  <div>上传人：{{item2.createUser}}</div>
                  <div>时间：{{item2.createTime}}</div>
                </div>
              </div>
            </li>
          </ul>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { async } from "q";
export default {
  data: function() {
    return {
      productCount: "",
      materialCount: "",
      typeName: "",
      typeList: [],
      total: "",
      gateImgList: [],
      contentName: "",
      src1: require("../../../assets/img/icon/video.png"),
      src2: require("../../../assets/img/icon/sucai.png"),
      searchValue: "", //搜索框
      material: "", //素材
      video: "" //成片
    };
  },
  methods: {
    // 成片库
    goVideoLeft: function() {
      this.$router.push({
        path: "/videolist2",
        query: {
          from: 1,
          videoTypeId: 1
        }
      });
    },
    // 素材库
    goVideoRight: function() {
      this.$router.push({
        path: "/videolist2",
        query: {
          from: 1,
          videoTypeId: 0
        }
      });
    },
    // 综合检索
    integSearch: function() {
      if (this.typeName == "" && this.searchValue == "") {
        this.$message.info("请选择搜索条件");
      } else {
        this.$router.push({
          path: "/videolist2",
          query: {
            from: true,
            typeName: this.typeName,
            retrieval: this.searchValue
          }
        });
      }
    },
    // 查看全部
    checkAllData: function(cate, content) {
      var category = "";
      var type = "";
      if (cate) {
        category = cate;
        type = this.$route.query.type;
      }
      if (content) {
        category = this.$route.query.category;
        if (content == "新闻类") {
          type = "NEWS";
        } else if (content == "直播类") {
          type = "LIVE";
        } else if (content == "访谈类") {
          type = "VIEW";
        } else if (content == "作品类") {
          type = "WORKS";
        } else if (content == "其他类") {
          type = "OTHER";
        } else {
          type = "";
        }
      }

      this.$router.push({
        path: "/videolist2",
        query: {
          from: 1,
          cate: category,
          type: type
        }
      });
    },
    // 查看详情
    goDetail: function(id) {
      this.$router.push({
        path: "/videodetail2",
        query: {
          id: id,
          status: 0
        }
      });
    },
    //
    init: function() {
      var type = this.$route.query.type;
      if (type == "NEWS") {
        this.contentName = "新闻类";
      } else if (type == "LIVE") {
        this.contentName = "直播类";
      } else if (type == "VIEW") {
        this.contentName = "访谈类";
      } else if (type == "WORKS") {
        this.contentName = "作品类";
      } else if (type == "OTHER") {
        this.contentName = "其他类";
      } else {
        this.contentName = "";
      }
    },
    selectTypeName: function() {},
    // 获取文艺类视频的二级分类
    getTypeList: async function() {
      var res = await this.$http.get("/v1/index/videoTypeList");
      var { code, data } = res.data;
      if (code == 0) {
        this.typeList = data;
        // this.videoTwoCate = data;
        console.log(this.typeList);
      }
    },
    // 根据内容分类查询视频列表并分栏显示
    // 新闻类，直播类，访谈类，作品类，其他类
    getContentTypeAndCateGory: async function() {
      var res = await this.$http.get(
        `/v1/index/contentTypeAndCategory?contentType=${this.$route.query.type}`
      );
      var { code, data, message } = res.data;
      if (code == 0) {
        this.material = data.material;
        this.video = data.video;
        this.gateImgList = data.data;
        console.log(this.gateImgList);
      }
    },
    // 根据视频门类查询视频列表
    getVideoInfoByCategory: async function() {
      var res = await this.$http.get(
        `/v1/index/videoInfoByCategory?category=${this.$route.query.category}`
      );
      var { code, data, message } = res.data;
      if (code == 0) {
        this.material = data.material;
        this.video = data.video;
        this.gateImgList = data.data;
        console.log(data);
      }
    }
  },
  mounted: function() {
    this.init();
    this.getTypeList();
    if (this.$route.query.type) {
      this.getContentTypeAndCateGory();
    }
    if (this.$route.query.category) {
      this.getVideoInfoByCategory();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/imgListFlow.css";
// 搜索框
.v_search {
  position: relative;
  height: 86px;
  line-height: 86px;
  width: 1200px;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 30px;
  z-index: 3;
  padding: 0 30px;

  // line-height: 90px;
  .el-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .left_btn {
    cursor: pointer;
    color: #fff;
    border-radius: 13px;
    padding: 10px;
    text-align: center;
    .tt {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .line {
    display: inline-block;
    width: 1px;
    height: 39px;
    background-color: #ccc;
    margin: 0 20px;
    vertical-align: middle;
  }
}
// 面包屑导航
.nav_bread {
  padding: 0 20px;
  width: 1200px;
  margin: 20px auto;
  height: 80px;
  line-height: 80px;
  background-color: #fff;
  .el-breadcrumb {
    height: 80px;
    line-height: 80px;
  }
  .el-input {
    width: 200px;
    margin-right: 20px;
  }
  .nav-right-tab {
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    width: 80px;
    height: 40px;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    div {
      border-right: 1px solid #ccc;
    }
  }
}
// 搜索分类
.red {
  color: red;
}
.text-color-blue {
  color: #0066cc;
}
.sea-list {
  background-color: #fff;
  padding: 20px 20px;

  .sea-tab {
    .sea-title {
      padding: 20px;
      border-bottom: 1px dotted #ccc;
      a {
        text-decoration: underline;
        color: #0066cc;
      }
    }
  }
}
//
.imgListFlow li {
  width: 23%;
  float: left;
  margin-right: 2.5%;
  &:last-child {
    margin-right: 0px;
  }
  &:first-child {
    margin-left: 0px;
  }
  margin-bottom: 25px;
  text-align: center;
  position: relative;
  .li-search-text {
    div {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
      text-align: center;
    }
  }
}
// 搜索框
// .v_search {
//   position: relative;
//   z-index: 3;
//   width: 1200px;
//   height: 86px;
//   line-height: 86px;
//   background-color: #fff;
//   margin: 0 auto;
//   margin-bottom: 20px;
//   padding: 0 30px;
//   .el-row {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
//   .left_btn {
//     cursor: pointer;
//     color: #fff;
//     border-radius: 13px;
//     padding: 10px;
//     text-align: center;
//     .tt {
//       font-size: 18px;
//       font-weight: bold;
//     }
//   }
//   .line {
//     display: inline-block;
//     width: 1px;
//     height: 39px;
//     background-color: #ccc;
//     margin: 0 20px;
//     vertical-align: middle;
//   }
// }
</style>


// WEBPACK FOOTER //
// src/components/home/searchpages/searchpages.vue